import { render, staticRenderFns } from "./colorPallete.vue?vue&type=template&id=f22c138a&scoped=true"
import script from "./colorPallete.vue?vue&type=script&lang=js"
export * from "./colorPallete.vue?vue&type=script&lang=js"
import style0 from "./colorPallete.vue?vue&type=style&index=0&id=f22c138a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f22c138a",
  null
  
)

export default component.exports